<script lang="ts">
  import Auth from './auth.svelte';

  import { dom2text } from './dom2text'
  import { fetchAudio } from './fetchAudio';
  import { watchTimeline } from './timeline'

  let hashtagInput = ''
  let socket: WebSocket | null = null

  let timelineName = 'ローカルタイムライン'

  let audioSourceURL: string = ''
  
  let statuses: { text: string, username: string }[] = []

  async function playSound(username: string, text: string) {
    const speechText = `${username}さん、${text}`
    const audioBlob = await fetchAudio(speechText)
    audioSourceURL = URL.createObjectURL(audioBlob)
    new Audio(audioSourceURL).play()
  }

  function watch() {
    if(socket === null) {
      const hashtag = /(^$|^\s+$)/.test(hashtagInput) ? null : hashtagInput
      if(hashtag === null) {
        console.log('Local Timeline')
        timelineName = 'ローカルタイムライン'
      } else {
        console.log('Tag Timeline')
        timelineName = `タグタイムライン: ${hashtag}`
      }
      socket = watchTimeline(hashtag, (text, username) => {
        statuses = [{text, username}, ...statuses]
        playSound(username, dom2text(text))
      })
    }
  }

  function stop() {
    if(socket !== null) {
      socket.close()
      socket = null
    }
  }
</script>

<div class="container">
  <div class="search-box">
    <div class="search-row">
      <div class="hash">#</div>
      <input
        type="text"
        class="hashtag-input"
        placeholder="展覧会"
        bind:value={hashtagInput}
      >
    </div>
    {#if socket === null}
      <button on:click={watch}>開始</button>
    {:else}
      <div>{ timelineName }</div>
      <button on:click={stop}>停止</button>
    {/if}
  </div>
  <div>
    {#each statuses as status}
      <div>
        {status.username}: { dom2text(status.text) }
      </div>
    {/each}
  </div>
  <audio autoplay>
    <source src={audioSourceURL} />
  </audio>
</div>

<style lang="scss" scoped>
  .container {
    .search-box {
      padding: 1rem;
      border: solid 1px #dddddd;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .search-row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 1rem;
        .hash {
          line-height: 40px;
        }
        .hashtag-input {
          margin: 0;
          border: none;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  button {
    background-color: transparent;
    padding: .3rem .8rem;
    border: solid 1px #dddddd;
    transition: background-color .3s;
    &:hover {
      cursor: pointer;
      background-color: #dddddd;
    }
  }
  
</style>